<script setup>
import { cn } from "@/lib/utils";
import { DropdownMenuLabel, useForwardProps } from "reka-ui";
import { computed } from "vue";

const props = defineProps({
  inset: {
    type: Boolean,
    default: false,
  },
  class: {
    type: [String, Array, Object],
    default: "",
  },
});

const delegatedProps = computed(() => {
  // eslint-disable-next-line no-unused-vars
  const { class: _, ...delegated } = props;
  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <DropdownMenuLabel
    v-bind="forwardedProps"
    :class="
      cn(
        'vf-px-2 vf-py-1.5 vf-text-sm vf-font-semibold',
        props.inset && 'vf-pl-8',
        props.class
      )
    "
  >
    <slot />
  </DropdownMenuLabel>
</template>
